import React from "react";
import { Spin } from "antd";

export default function LoadingFallback({ label = "A carregar..." }) {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: 240 }}>
      <Spin tip={label} />
    </div>
  );
}
